/* Copyright (C) 2021 ev-i Informationstechnologie GmbH */

export enum PlotPaperQuality {
    LASER_80 = "Laserplot 80g/m2",
    LASER_90 = "Laserplot 90g/m2",
    INKJET_80 = "Tintenstrahlplot 80g/m2",
    INKJET_90 = "Tintenstrahlplot 90g/m2"
}